import { Component, Input, OnInit } from '@angular/core';
import { texts } from '../activity-item.texts';

@Component({
  standalone: false,
  selector: 'sc-activity-item-project-messaging-done',
  templateUrl: './activity-item-project-messaging-done.component.html',
  styleUrls: ['./activity-item-project-messaging-done.component.scss']
})
export class ActivityItemProjectMessagingDoneComponent implements OnInit {
  
  @Input()
  activity : any;

  @Input()
  condensed = false;

  @Input()
  showProjectName = false;

  @Input()
  language: 'de' | 'en' = 'de';

  texts = texts;

  constructor() { }

  ngOnInit(): void {
  }

}
